import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel";
import { SectionTitle } from "./PublicLayout";
import { useFetch } from "../../lib/hooks";

export const Testimonials = () => {
  const { data } = useFetch("/testimonials");
  if (!data?.length) return null;
  return (
    <section className="bg-white py-20 md:py-28" data-testid="home-testimonials-section">
      <div className="container-x">
        <SectionTitle eyebrow="Testimonials" title="Words from our travellers" />
        <Carousel className="mt-12" opts={{ align: "start" }}>
          <CarouselContent>
            {data.map((t) => (
              <CarouselItem key={t.id} className="md:basis-1/2 lg:basis-1/3">
                <figure className="h-full rounded-2xl border border-slate-200 bg-[#F8FAFC] p-7" data-testid={`testimonial-${t.id}`}>
                  <Quote className="h-7 w-7 text-[#FD691B]" />
                  <blockquote className="mt-4 text-sm leading-relaxed text-slate-700">{t.text}</blockquote>
                  <figcaption className="mt-5 font-display text-sm font-bold">{t.name}{t.trip && <span className="block text-xs font-medium text-slate-500">{t.trip}</span>}</figcaption>
                </figure>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="mt-6 flex justify-end gap-2 [&>button]:static [&>button]:translate-y-0">
            <CarouselPrevious data-testid="testimonials-prev-btn" />
            <CarouselNext data-testid="testimonials-next-btn" />
          </div>
        </Carousel>
      </div>
    </section>
  );
};
